import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { A11yModule } from '@angular/cdk/a11y';
import { FsxButtonComponent, FsxButtonTypeEnum } from 'fsx-component-library';
import { ChunkRecoveryService } from '../../core/chunk-recovery/chunk-recovery.service';

/**
 * Full-screen fallback shown when automatic chunk-load recovery has exhausted its
 * reload attempts (a persistently broken deploy). Gives the user a clear manual
 * reload instead of a blank or half-broken screen (see {@link ChunkRecoveryService}).
 */
@Component({
  selector: 'app-load-failure',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [A11yModule, FsxButtonComponent],
  templateUrl: './app-load-failure.component.html',
  styleUrls: ['./app-load-failure.component.scss'],
})
export class AppLoadFailureComponent {
  /** Coordinator exposing whether recovery has given up and driving the manual reload. */
  private readonly recovery = inject(ChunkRecoveryService);

  /** True when automatic recovery is exhausted and the fallback must be shown. */
  protected readonly loadFailed = this.recovery.loadFailed;

  /** Button type enum for the reload action. */
  protected readonly FsxButtonTypeEnum = FsxButtonTypeEnum;

  /** Clears recovery state and performs a manual full reload. */
  protected onReloadClicked(): void {
    this.recovery.reloadNow();
  }
}
